import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot } from '@angular/router';

import { AdminService } from './admin.service';
import { FeatureToggleService } from './feature-toggle.service';

@Injectable()
export class GuardSubscriptionService implements CanActivate {

	constructor(
		private adminService: AdminService,
		private ftService: FeatureToggleService
	) { }

	async canActivate(route: ActivatedRouteSnapshot) {
		const appName = route.data.appName;
		// TODO: currently child canActivate is called before parent resolved.. so the subscriptions might not be fetched yet
		// Waiting for angular to provide some solutions
		const subs = this.adminService.subscriptions.getValue();
		if (!subs) {
			await this.adminService.getSubscriptions();
		}
		return this.adminService.checkHasSub(appName);
	}
}



// WEBPACK FOOTER //
// ./src/app/common-services/guard-subscription.service.ts